import { List, Modal, Text } from "@mantine/core";
import PropTypes from "prop-types";

function InstructionModal({ open, setOpen }) {
  return (
    <Modal
      size="70%"
      opened={open}
      onClose={() => setOpen(false)}
      overflow="inside"
      height="100%"
      style={{ height: "100%" }}
    >
      <Text
        align="center"
        weight={700}
        size="md"
        style={{ borderBottom: "3px solid #0063F8", marginTop: "1vmax" }}
      >
        GENERAL INSTRUCTIONS
      </Text>
      <div>
        <List withPadding type="ordered" style={{ margin: "1vmax" }}>
          <List.Item>
            There are 9 major profiles inside Spider. A few profiles have
            further domains inside it (even sub-domains). The below list shows
            the division-
            <Text>📌 Profiles - Domains - Sub-Domains</Text>
            <List withPadding listStyleType="circle">
              <List.Item style={{ margin: "1vmax" }} className="weight">
                Algos
              </List.Item>

	      <List.Item style={{ margin: "1vmax" }}>
                <span className="weight"> Software: </span>
                <List withPadding listStyleType="lower-roman">
                  <List.Item>Application Development</List.Item>
                  <List.Item>UI/UX</List.Item>
                  <List.Item>Devops</List.Item>
                  <List.Item>CyberSecurity</List.Item>
                  <List.Item>Networks</List.Item>
                  <List.Item>Blockchain</List.Item>
                </List>
              </List.Item>

              <List.Item style={{ margin: "1vmax" }}>
                <span className="weight"> Embedded Systems &amp; Electronics:</span>
                <List withPadding listStyleType="lower-roman">
                  <List.Item>Electronics</List.Item>
                  <List.Item>Embedded Systems</List.Item>
                </List>
              </List.Item>
              <List.Item style={{ margin: "1vmax" }}>
                <span className="weight">Robotics:</span>
                <List withPadding listStyleType="lower-roman">
                  <List.Item>Mechanics</List.Item>
                  <List.Item>Control Systems/Simulations</List.Item>
                  <List.Item>Embedded Systems</List.Item>
                </List>
              </List.Item>
              <List.Item style={{ margin: "1vmax" }} className="weight">
                  Machine Learning
              </List.Item>
            </List>
          </List.Item>
          <List.Item style={{ margin: "1vmax" }}>
            <span className="weight">Plagiarism</span> is strictly{" "}
            <span className="weight">not allowed.</span> Consider this a
            learning phase and make the best out of it.
          </List.Item>
          <List.Item style={{ margin: "1vmax" }}>
            The Deadlines are to be{" "}
            <span className="weight">followed strictly,</span> and in case of
            unavoidable situation, contact your mentor. Deadlines will be
            notified for each task in the portal.
          </List.Item>
        </List>
      </div>
    </Modal>
  );
}
InstructionModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.bool,
};
export default InstructionModal;
